(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["revlon-bundles-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.rvb[data-section-id="{{ section.id }}"]');
  if(!root) return;

  var sticky = root.querySelector('[data-rvb-sticky]');
  var sTitle = root.querySelector('[data-rvb-title]');
  var sPrice = root.querySelector('[data-rvb-price]');
  var sCta = root.querySelector('[data-rvb-cta]');

  var cards = root.querySelectorAll('[data-rvb-card]');
  if(!cards.length) return;

  function moneyFromData(card){
    var price = card.getAttribute('data-price') || '';
    var compare = card.getAttribute('data-compare') || '';
    if(compare && compare !== price){
      return price + "  •  Antes " + compare;
    }
    return price;
  }

  function selectCard(card){
    cards.forEach(function(c){ c.classList.remove('is-selected'); });
    card.classList.add('is-selected');

    var title = card.getAttribute('data-title') || 'Bundle seleccionado';
    var priceText = moneyFromData(card);
    var addUrl = card.getAttribute('data-add') || '#';

    if(sTitle) sTitle.textContent = title;
    if(sPrice) sPrice.textContent = priceText;
    if(sCta) sCta.setAttribute('href', addUrl);

    // Improve accessibility: focus sticky button after selection (mobile)
    // (commented to avoid jumpy UX)
    // if(window.innerWidth < 900) sCta && sCta.focus();
  }

  cards.forEach(function(card){
    card.addEventListener('click', function(e){
      var isLink = e.target.closest('a');
      // If user clicked "Ver" or "Comprar", let it behave normally
      if(isLink) return;
      selectCard(card);
    });
  });

  // Default selection: recommended first, else first card
  var recommended = root.querySelector('[data-rvb-recommended="true"]');
  selectCard(recommended || cards[0]);

})();

(function(){
  var root = document.querySelector('.rvb[data-section-id="{{ section.id }}"]');
  if(!root) return;

  var track = root.querySelector('[data-rvb-steps]');
  var dots = root.querySelectorAll('.rvb__dotx');
  if(!track || !dots.length) return;

  function setDot(i){
    dots.forEach(function(d, idx){
      d.style.opacity = (idx === i) ? '1' : '.35';
    });
  }

  function onScroll(){
    var cards = track.querySelectorAll('.rvb__stepCard');
    if(!cards.length) return;
    var left = track.scrollLeft;
    var w = cards[0].getBoundingClientRect().width + 12; // card + gap
    var idx = Math.round(left / w);
    idx = Math.max(0, Math.min(dots.length - 1, idx));
    setDot(idx);
  }

  setDot(0);
  track.addEventListener('scroll', function(){ window.requestAnimationFrame(onScroll); });
})();




  } catch(e) { console.error(e); }
})();
})();
